import React, { Component } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import * as asyncStateAction from '../../../actions/asyncStateAction';
import servicesConfig from '../../../services/servicesConfig';
import commonStore from '../../../store/commonStore.js';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import * as deviceInfoService from '../../../utils/general/deviceInfoService';
import {
    isCVLink,
    isAppInsideCVResearchUIiFrame,
    executeWindowOpenForEPFToken,
    isThirdPartyTokenAuthorization,
    isCV2Link,
    getCVFrameUrl,
    addParam,
} from '../../../utils/general/general';
import RSCH_HTML_TRACKING_CONFIG from '../../../readership/trackingConfig';
import RenditionUrlGenerator from "../../../utils/api/renditionUrlGenerator";
import { isEmpty, isEqual } from 'lodash';
import { getStaticEPFAccessToken } from '../../../utils/general/EpfTokensUtils';

interface ICvMacroToolsProps {
    cvMacroToolsData: any;
    propsCallback: () => void;
    applyData: () => {};
    isExternalUser?: boolean;
    menuCode: any;
}

export class CvMacroTools extends Component<ICvMacroToolsProps, any> {
    constructor(props: ICvMacroToolsProps) {
        super(props);
        if (this.isEntitled()) {
            props.applyData();
        }
    }

    public isEntitled = () => {
        const initialData = commonStore.getState().asyncStateReducer.initialData;
        return initialData.isEntitled('CV_MCRO_TOOLS');
    };

    public showPopUp(url: string, name: string, position: number) {
        RSCH_HTML_TRACKING_CONFIG.trackCVMacroToolsEvent(name, position,url);
        if (isThirdPartyTokenAuthorization()) {
            executeWindowOpenForEPFToken(url);
            return;
        }

        let target = '_blank';
        if (
            (isCVLink(url) &&
            !isCV2Link(url) &&
            isAppInsideCVResearchUIiFrame() &&
            url.indexOf(window.HTML_RENDITION.initialData.html_origin) > -1) || (this.props.isExternalUser)
        ) {
            target = '_self';
        }
        const win = window.open(url, target);
        win?.focus();
    }

    public buildCVMacrotoolLinks() {
        setTimeout(() => {
            this.props.propsCallback();
        }, 100);
        const {cvMacroToolsData, menuCode} = this.props;
        const environment = window.HTML_RENDITION.initialData.environment;
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        if (_isEmpty(cvMacroToolsData.data)) {
            return null;
        }
        return cvMacroToolsData.data.map((publication: any, index: number) => {
            const displayName = publication.displayName;
            let thumbnailURL = publication.thumbnailURL;
            let url = "";
            if (!_isEmpty(publication.newURL)) {
                let pdpValue = 'pdp_all';
                if (displayName === "Global Theme Machine") {
                    pdpValue = "pdp_thm";
                }
                let publicationNewURL = publication.newURL;
                const epfToken =  getStaticEPFAccessToken();
                if (!isEmpty(epfToken)) {
                    publicationNewURL = addParam(publicationNewURL, '__epftoken', epfToken);
                }
                if (this.props.isExternalUser) {
                    url = publicationNewURL;
                } else if (!_isEmpty(menuCode)) { 
                    url = getCVFrameUrl(menuCode, publicationNewURL, 'pdp_all');
                } else {
                    url = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + '/cv2/go/RSCH_LANDING_PAGE/' + btoa('__NAVIGATION_BASE64__/cvr/citiresearchui/eppublic/pdp_all/iframe/' +  btoa(publicationNewURL));
                    const epfTokenFrameUrl =  getStaticEPFAccessToken();
                    if (!isEmpty(epfTokenFrameUrl)) {
                        url = url + `?__epftoken=${epfTokenFrameUrl}`;
                    }      
                }
            } else {
                let publicationURL = publication.url;
                const epfToken =  getStaticEPFAccessToken();
                if (!isEmpty(epfToken)) {
                    publicationURL = addParam(publicationURL, '__epftoken', epfToken);
                }
                if (this.props.isExternalUser) {
                    url = publicationURL;
                } else {
                    url = getCVFrameUrl(menuCode, publicationURL, 'pdp_all');
                }
            }
            if (publication.showOnHTMLRendition === false) {
                return;
            }
            if (deviceInfoService.isDeviceScreenType()) {
                if (thumbnailURL.includes("ir.citi.com/")) {
                    thumbnailURL = thumbnailURL.replace("ir.citi.com/", "ir.citi.com/bbImg/");
                }  
                var ajaxPromise = RenditionUrlGenerator.URL_GENERATOR.generateAuthFileLinkPublicURL(thumbnailURL);
                ajaxPromise.done(function (result : any){
                    if (result) {
                        thumbnailURL = result.url;
                    }
                }.bind(this));
            }
            return (
                <div className="financials" key={'mt_' + index}>
                    <div className="cvmacrotools-publications">
                        {thumbnailURL &&
                            <React.Fragment>
                                {
                                    <span className='icon-svg-parent'>
                                        <span className="icon-svg cvmacro-icon"><img src={thumbnailURL} alt={displayName}/></span>
                                    </span>
                                }
                                <a tabIndex={0} role="link" aria-label={displayName}
                                   onClick={() => {
                                    if (!_isEmpty(publication.newURL)) {
                                        window.open(url, this.props.isExternalUser ? "_self" : "_blank");
                                    } else {
                                        this.showPopUp(url, displayName, index + 1);
                                    }
                                   }}
                                   onKeyPress={(e) => {
                                    if (!_isEmpty(publication.newURL)) {
                                        window.open(url, this.props.isExternalUser ? "_self" : "_blank");
                                    } else {
                                        enterKeyPressed(e, this.showPopUp.bind(this, url, displayName, index + 1));
                                    }
                                   }}
                                >{displayName}</a>
                            </React.Fragment>
                        }
                    </div>
                </div>
            );
        });
    }

    public render() {

        if (!this.isEntitled()) {
            return null;
        }
        return (
            this.buildCVMacrotoolLinks()
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        cvMacroToolsData: state.asyncStateReducer.cvMacroToolsData,
        menuCode: state.commonStateReducer.menuCode,
    };
};

const mapDispatchToProps = (dispatch: (any)) => ({
    applyData: () => dispatch(asyncStateAction.fetchCvMacroTools(servicesConfig.GET_CV_MACRO_TOOLS)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CvMacroTools);